import { Component, Prop, Vue } from "vue-property-decorator";
import { Dropdown, Menu, Icon } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { CommonLocale } from "@/locales/localeid";
import { LanguageSkill } from "@/util/enum";

enum LessonPlanEditorActionEnum {
	Edit,
	MoveUp,
	MoveDown,
	Save,
	Cancel,
	ManageOrder
}

export interface LessonPlanEditorActionProps {
	isEdit?: boolean;
	disabled?: boolean;
	showMoveUp?: boolean;
	showMoveDown?: boolean;
	showEdit?: boolean;
	content?: any;
	onEditing?: (isEdit: boolean) => Promise<void>;
	onMoveUping?: () => void;
	onMoveDowning?: () => void;
	onSaving?: () => void;
	onManageOrder?: () => void;
}

@Component({
	components: {
		Dropdown,
		Menu,
		MenuItem: Menu.Item,
		Icon
	}
})
export default class LessonPlanEditorAction extends Vue {
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: false }) disabled!: boolean;
	@Prop({ default: true }) showMoveUp!: boolean;
	@Prop({ default: true }) showMoveDown!: boolean;
	@Prop({ default: true }) showEdit!: boolean;
	@Prop({ default: null }) content!: any;
	@Prop({ default: () => {} }) onEditing!: (isEdit: boolean) => Promise<void>;
	@Prop({ default: () => {} }) onMoveUping!: () => void;
	@Prop({ default: () => {} }) onMoveDowning!: () => void;
	@Prop({ default: () => {} }) onSaving!: () => void;
	@Prop({ default: () => {} }) onManageOrder!: () => void;

	get lessonPlanEditorActionEnum() {
		return LessonPlanEditorActionEnum;
	}
	get commonLocale(): any {
		return CommonLocale;
	}
	get isReader() {
		return this.content.languageSkillId == LanguageSkill.Read;
	}
	onActionChange(e) {
		switch (e.key) {
			case LessonPlanEditorActionEnum.Edit:
				this.onEditing(true);
				break;
			case LessonPlanEditorActionEnum.MoveUp:
				this.onMoveUping();
				break;
			case LessonPlanEditorActionEnum.MoveDown:
				this.onMoveDowning();
				break;
			case LessonPlanEditorActionEnum.Save:
				this.onSaving();
				break;
			case LessonPlanEditorActionEnum.Cancel:
				this.onEditing(false);
				break;
			case LessonPlanEditorActionEnum.ManageOrder:
				this.onManageOrder();
				break;
			default:
				break;
		}
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}
}
